import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SignInButton, SignUpButton, useClerk, useUser, SignOutButton } from '@clerk/clerk-react';
export default function Navbar() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const { user } = useUser();


  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          {/* <Link to="/" className="logo-link">
            WizardPortrait
          </Link> */}
        </div>
        
        <div className="navbar-links">
          {/* <Link to="/pricing" className="nav-link">Pricing</Link> */}
          {user ? (
            <div className="user-menu">
              {/* <span className="user-greeting">Hello, {user?.firstName || 'Wizard'}</span> */}
              <SignOutButton>
                <button className="sign-out-button">
                  Sign Out
                </button>
              </SignOutButton>
            </div>
          ) : (
            <SignInButton mode="modal" className="nav-link auth-link">Sign In</SignInButton>
          )}
        </div>
      </div>
      
      <style jsx>{`
        .navbar {
          position: absolute;
          top: 0;
          right: 0;
          width: 200px;
          z-index: 1000;
          height: 130px;
          padding: 1rem 2rem;
          display: flex;
          align-items: center;
 
        }
        
        .navbar-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .navbar-logo {
          font-weight: 600;
        }
        
        .logo-link {
          color: var(--accent, #F9B932);
          text-decoration: none;
          font-family: var(--serif, serif);
          font-size: 1.2rem;
        }
        
        .navbar-links {
          display: flex;
          align-items: center;
          gap: 1.5rem;
        }
        
        .nav-link {
          color: white;
          text-decoration: none;
          font-size: 0.95rem;
          padding: 0.5rem;
          transition: color 0.3s ease;
        }
        
        .nav-link:hover {
          color: var(--accent, #F9B932);
        }
        
        .auth-link {
          background: var(--primary, #6A3EA1);
          color: white;
          padding: 0.5rem 1.2rem;
          border-radius: 50px;
          transition: all 0.3s ease;
        }
        
        .auth-link:hover {
          background: var(--secondary, #9857D3);
          color: white;
          transform: translateY(-2px);
        }
        
        .user-menu {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        
        .user-greeting {
          color: white;
          font-size: 0.95rem;
        }
        
        .sign-out-button {
          background: transparent;
          color: var(--accent, #F9B932);
          border: 1px solid var(--accent, #F9B932);
          padding: 0.4rem 1rem;
          border-radius: 50px;
          font-size: 0.85rem;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .sign-out-button:hover {
          background: var(--accent, #F9B932);
          color: black;
        }
        
        @media (max-width: 768px) {
          .navbar-container {
            flex-direction: column;
            gap: 1rem;
          }
          
          .navbar-links {
            width: 100%;
            justify-content: space-between;
          }
        }
      `}</style>
    </nav>
  );
}